module.exports = __webpack_public_path__ + "src/img/audioMask.25526f01.jpg";